import { Outlet } from "react-router";
import Footer from "./Footer";
import ScrollToTop from "../../utils/ScrollToTop";
import Navbar from "./Navbar";
import Whatsapp from "../whatsapp/Whatsapp";
import BottomNavigation from "./BottomNavigation";
import TickerBar from "../TickerBar";

function RootLayout() {
  return (
    <>
      <ScrollToTop />
      <TickerBar />
      <Navbar />
      <Outlet />
      <Whatsapp />
      <BottomNavigation />
      <Footer />
    </>
  );
}

export default RootLayout;
